export const environment = {
  "production": false,
  "apiEndPoint": "https://dev.invonow.com",
  "appVersion": "1.0"
};
